module.exports = __webpack_public_path__ + "static/image/DIN-Bold.otf?20720c3ac567a72d0ef973d2e703dfae";